module.exports = __webpack_public_path__ + "img/snb_gsnd.3c87f3e1.svg";